// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../model/types.tsx';

// In the future, ideally universalDispatch is the ONLY action connected to the store,
// and instead we import disconnected "actions" to the call site to be fired by universalDispatch
export const universalDispatch =
	({ fn }: { fn: () => Action<State, void, void> }): Action<State> =>
	({ dispatch }) => {
		dispatch(fn());
	};
